import React from "react"
import PropTypes from "prop-types"
import moment from 'moment'
import StandardButton from '../app_components/StandardButton'
import MeetingResponse from './MeetingResponse'

class MeetingButtonSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      responseType: '',
      responseFormOpen: false
    }

    this.toggleResponseForm = this.toggleResponseForm.bind(this)
    this.openChange = this.openChange.bind(this)
  }

  openChange() {
    this.setState({
      responseFormOpen: true,
      responseType: 'change'
    })
  }

  toggleResponseForm(type) {
    this.props.getAllMeetings()
    this.setState({
      responseFormOpen: !this.state.responseFormOpen,
      responseType: type
    })
  }

  renderFooterButtons() {
    if (this.props.meeting.status === 'Cancelled') {
      return null
    }

    if(moment(this.props.meeting.meeting_time).isBefore(moment(Date.today)) && this.props.meeting.accepted != true){
      return null
    }

    if(this.props.meeting.accepted === false && this.props.meeting.requestor_id != this.props.currentUser.id) {
      return(
        <div className="upcomingLexCard__actions">
          <div className="upcomingLexCard__actionWrap">
            <StandardButton
              primary={true}
              fullWidth
              text="Respond to Request"
              icon="check-circle"
              onClick={() => this.toggleResponseForm('respond')}
            />
          </div>
        </div>
      )
    }

    if(this.props.meeting.status != "Cancelled") {
      return(
        <div className="upcomingLexCard__actions">
          <div className="upcomingLexCard__actionWrap">
            <StandardButton
              primary={false}
              fullWidth
              text="Change"
              icon="edit"
              onClick={() => this.toggleResponseForm('change')}
            />
          </div>
          <div className="upcomingLexCard__actionWrap">
            <StandardButton
              primary={true}
              fullWidth
              text="Plan Lex"
              icon="calendar"
              iconSolid
              onClick={() => window.location.assign(`/meetings/${this.props.meeting.id}`)}
            />
          </div>
        </div>
      )
    }

    return null
  }

  render() {
    return(
      <div>
        {this.state.responseFormOpen &&
          <MeetingResponse
            type={this.state.responseType}
            onClose={() => this.toggleResponseForm('')}
            meeting={this.props.meeting}
            getAllMeetings={this.props.getAllMeetings}
          />}
        {this.renderFooterButtons()}
      </div>
    )
  }
}

export default MeetingButtonSection;
